import { postPaymentMethodModificationPreview } from '@nemuru-eng/js-api-client';
import { useCallback, useState } from 'react';

import { useRequest } from '@/hooks/requests/useRequest';

type RequestParams = Parameters<typeof postPaymentMethodModificationPreview>[0];
type Response = Awaited<ReturnType<typeof postPaymentMethodModificationPreview>>;

export const usePostPaymentMethodModificationPreview = () => {
  const { request, loading } = useRequest();
  const [paymentMethodModificationPreview, setPaymentMethodModificationPreview] = useState<Response | undefined>(
    undefined,
  );
  const [error, setError] = useState<Error | undefined>(undefined);

  const submit = useCallback(
    async (params: RequestParams): Promise<Response> => {
      setError(undefined);

      try {
        const preview = await request(postPaymentMethodModificationPreview, params, { notifyOnSuccess: false });
        setPaymentMethodModificationPreview(preview);
        return preview;
      } catch (err) {
        const previewError = err as Error;
        setError(previewError);
        throw previewError;
      }
    },
    [request],
  );

  const reset = useCallback(() => {
    setPaymentMethodModificationPreview(undefined);
    setError(undefined);
  }, []);

  return {
    paymentMethodModificationPreview,
    loading,
    error,
    submit,
    reset,
  };
};
